import { render } from "./HuaweiLogo.vue?vue&type=template&id=3a276a20&ts=true"
import script from "./HuaweiLogo.vue?vue&type=script&lang=ts"
export * from "./HuaweiLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__